import React from "react";
import styled, { css } from "styled-components";
import { hoverTips } from "utils/mixin";

const buttonTypeVariants = {
  normal: css`
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.fontColor};

    :hover {
      background-color: ${({ theme }) => theme.gray};
      color: ${({ theme }) => theme.white};
    }
  `,
  danger: css`
    background-color: ${({ theme }) => theme.red};
    color: ${({ theme }) => theme.white};

    :hover {
      background-color: ${({ theme }) => theme.weakRed};
      color: ${({ theme }) => theme.white};
    }
  `,
};

const StyledButtonContainer = styled.div`
  display: flex;
  align-items: center;
  row-gap: 3px;
`;

const StyledMessage = styled.div`
  padding: 3px 0;
  opacity: ${({ show }) => (show ? 1 : 0)};
  color: ${({ theme }) => theme.weakRed};
  font-size: ${({ theme }) => theme.fontSize.lsmall};
  height: ${({ theme }) => theme.fontSize.lsmall};
`;

const StyledButton = styled.button`
  cursor: pointer;
  padding: 8px 12px;
  border: 0;
  outline: none;
  border-radius: 3px;
  transition: 0.4s;

  ${({ type }) => buttonTypeVariants[type]}
`;

const Button = ({
  messageArea = true,
  message = "",
  marginTop = "5px",
  type = "normal",
  title = "",
  onClick,
  children,
  auth = true
}) => {
  if(!auth) return null
  return (
    <StyledButtonContainer>
      {messageArea && <StyledMessage show={!!message}>{message}</StyledMessage>}
      <StyledButton
        marginTop={marginTop}
        title={title}
        type={type}
        onClick={onClick}
      >
        {children}
      </StyledButton>
    </StyledButtonContainer>
  );
};

export default Button;

export { StyledButton };
